module.exports = __webpack_public_path__ + "assets/img/DigitalPictogram_FACEBOOK.e44d4dd6.svg";